import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Webvisibility() {
  return (
    <section className="web_visibility p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center resp_order"
          >
            <StaticImage
              src="../../images/services-usa/web/visibile_desktop.webp"
              alt="web development company"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={591}
              height={418}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Web Development for Multi-Channel <span>Visibility</span>
            </h2>
            <p>
              A website or web app is built to facilitate user engagement. Our
              web development services help create scalable digital platforms
              with intuitive UI/UX and performant functionalities for accessible
              online interaction. For further efficiency, we leverage threat
              resistance, tested architectures, continuous maintenance, and
              custom CMS solutions.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Webvisibility;
